export enum PartnerEnum {
  FTD = 'FTD',
  ATHENA = 'ATHENA'
}
